import {UserUpdatePhoneNumberModal as UserUpdatePhoneNumberModalBase} from "@pg-mono/user";

import {UserUpdatePhoneNumberModalProvider} from "../../providers/UserUpdatePhoneNumberModalProvider";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
}

export const HomeMatchBasicPreferencesFlowPhoneUpdateModal = (props: IProps) => {
    const {isOpen, onClose, onSuccess} = props;

    return (
        <UserUpdatePhoneNumberModalProvider onCloseOverride={onClose}>
            <UserUpdatePhoneNumberModalBase isOpen={isOpen} onSuccess={onSuccess} />
        </UserUpdatePhoneNumberModalProvider>
    );
};
import {UserUpdatePhoneNumberModal as UserUpdatePhoneNumberModalBase} from "@pg-mono/user";

import {UserUpdatePhoneNumberModalProvider} from "../../providers/UserUpdatePhoneNumberModalProvider";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
}

export const HomeMatchBasicPreferencesFlowPhoneUpdateModal = (props: IProps) => {
    const {isOpen, onClose, onSuccess} = props;

    return (
        <UserUpdatePhoneNumberModalProvider onCloseOverride={onClose}>
            <UserUpdatePhoneNumberModalBase isOpen={isOpen} onSuccess={onSuccess} />
        </UserUpdatePhoneNumberModalProvider>
    );
};
